import { useAssistantCloudStore } from './stores/assistant-cloud-store';

export async function ensureStoreInitialized(): Promise<void> {
  const store = useAssistantCloudStore.getState();
  if (!store.isInitialized) {
    await store.initialize();
  }
}
